import httpClient from '../utils/httpClient';

const API_URL = '/exam';

// ==================== PERÍODOS DE EXAMEN ====================

export const createExamPeriod = async (data) => {
  try {
    const response = await httpClient.post(`${API_URL}/periods`, data);
    return response;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const getAllExamPeriods = async (filters = {}) => {
  try {
    const params = new URLSearchParams(filters).toString();
    const response = await httpClient.get(
      `${API_URL}/periods${params ? `?${params}` : ''}`
    );
    return response;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const getExamPeriodById = async (id) => {
  try {
    const response = await httpClient.get(`${API_URL}/periods/${id}`);
    return response;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const updateExamPeriod = async (id, data) => {
  try {
    const response = await httpClient.put(`${API_URL}/periods/${id}`, data);
    return response;
  } catch (error) {
    throw error.response?.data || error;
  }
};

// ==================== PROGRAMACIÓN DE EXÁMENES ====================

export const scheduleExam = async (data) => {
  try {
    const response = await httpClient.post(`${API_URL}/schedule`, data);
    return response;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const getAllScheduledExams = async (filters = {}) => {
  try {
    const params = new URLSearchParams(filters).toString();
    const response = await httpClient.get(
      `${API_URL}/schedule${params ? `?${params}` : ''}`
    );
    return response;
  } catch (error) {
    throw error.response?.data || error;
  }
};

// ==================== INSCRIPCIONES ====================

export const registerToExam = async (data) => {
  try {
    const response = await httpClient.post(`${API_URL}/inscriptions`, data);
    return response;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const getAllExamInscriptions = async (filters = {}) => {
  try {
    const params = new URLSearchParams(filters).toString();
    const response = await httpClient.get(
      `${API_URL}/inscriptions${params ? `?${params}` : ''}`
    );
    return response;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const getInscriptionsByStudent = async (studentId) => {
  try {
    const response = await httpClient.get(
      `${API_URL}/inscriptions/student/${studentId}`
    );
    return response;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const getInscriptionsBySchedule = async (examScheduleId) => {
  try {
    const response = await httpClient.get(
      `${API_URL}/inscriptions/schedule/${examScheduleId}`
    );
    return response;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const cancelExamInscription = async (id, data) => {
  try {
    const response = await httpClient.put(
      `${API_URL}/inscriptions/${id}/cancel`,
      data
    );
    return response;
  } catch (error) {
    throw error.response?.data || error;
  }
};

// ==================== CALIFICACIONES ====================

export const recordExamGrade = async (data) => {
  try {
    const response = await httpClient.post(`${API_URL}/grades`, data);
    return response;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const getGradesByStudent = async (studentId) => {
  try {
    const response = await httpClient.get(
      `${API_URL}/grades/student/${studentId}`
    );
    return response;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const getGradesBySubject = async (subjectId) => {
  try {
    const response = await httpClient.get(
      `${API_URL}/grades/subject/${subjectId}`
    );
    return response;
  } catch (error) {
    throw error.response?.data || error;
  }
};
